const initialCalender = {
    calenders: [],
    calendermessages : {}
};

const calenderReducer = (calender = initialCalender, action) => {
    switch (action.type) {
        case 'ADD_CALENDER':
            return {
                ...calender, calendermessages: action.payload.data
            };
        case "DELETE_CALENDER":
            return {
                ...calender, calendermessages: action.payload.data
            };
        case "GET_CALENDER":
            return {
                ...calender, calenders: action.payload.data
            };
        default:return initialCalender;

    }
}
export default calenderReducer;